<!-- =========================================================================================
  File Name: UserView.vue
  Description: User View page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-user-view">
    <vs-alert color="danger" title="User Not Found" :active.sync="user_not_found">
      <span>User record with id: {{ $route.params.userId }} not found.</span>
      <span>
        <span>Check</span>
        <router-link :to="{name:'page-user-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <div id="user-data">
      <vx-card title="Información de la etapa" class="mb-base">
        <!-- Avatar -->
        <div class="vx-row">
          <!-- Avatar Col -->

          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table>
              <tr>
                <td class="font-semibold">Identificador</td>
                <td class="pl-4">{{ etapaData.IDETAPA }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Contratación asociada</td>
                <td class="pl-4">{{ etapaData.IDLICITACION }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Nombre etapa</td>
                <td class="pl-4">{{ etapaData.NOMBRE }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 1 -->

          <!-- Information - Col 2 -->
          <div class="vx-col flex-1" id="account-info-col-2">
            <table>
              <tr>
                <td class="font-semibold">Fecha creación etapa</td>
                <td class="pl-4">{{ etapaData.FECHA_CREA }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Fecha inicio presentación</td>
                <td class="pl-4">{{ etapaData.FECHA_INI }}</td>
              </tr>
              <tr>
                <td class="font-semibold">Fecha final presentación</td>
                <td class="pl-4">{{ etapaData.FECHA_FIN }}</td>
              </tr>
            </table>
          </div>
          <!-- /Information - Col 2 -->
          <div class="vx-col w-full flex" id="account-manage-buttons">
            <vs-button icon-pack="feather" icon="icon-edit" class="mr-4" @click="openEdit">Modificar</vs-button>
            <vs-button
              type="border"
              color="danger"
              icon-pack="feather"
              icon="icon-trash"
              @click="confirmDeleteRecord"
            >Eliminar</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import AgreementModule from '@/store/etapa-caso-module/moduleDataList.js'
//import LocationAgreementListView from "../location-agreement/LocationAgreementListView";

export default {
  components: {
    //      LocationAgreementListView
  },
  props: {
    etapaData: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      user_data: {},
      user_not_found: false
    }
  },
  computed: {
    userAddress () {
      let str = ''
      for (const field in this.user_data.location) {
        str += `${field} `
      }
      return str
    }
  },
  created () {
    if (!AgreementModule.isRegistered) {
      this.$store.registerModule('AgreementModule', AgreementModule)
      AgreementModule.isRegistered = true
    }
  },
  methods: {
    confirmDeleteRecord () {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirmar eliminar',
        text: `¿Desea eliminar la etapa "${this.etapaData.name}"?`,
        accept: this.deleteRecord,
        acceptText: 'Eliminar',
        cancelText: 'Cancelar'
      })
    },
    openEdit () {
      this.$emit('changeMode')
    },

    displayMessage () {
      this.$vs.dialog({
        color: 'primary',
        title: 'Modificar registro',
        text: `Modificación de convenio id=${  this.etapaData.id}`,
        accept: console.log('texto')
      })
    },
    deleteRecord () {
      const idAgreementTmp = this.etapaData.id
      const nameAgreementTmp = this.etapaData.name
      this.$store
        .dispatch('AgreementModule/removeAgreement', idAgreementTmp)
        .then(() => {
          this.$emit('closeView')
          this.$vs.notify({
            color: 'success',
            title: 'Etapa eliminada',
            text:
              `La etapa ${ 
                nameAgreementTmp 
              } ha sido eliminada del sistema.`
          })
        })
        .catch((ex) => {
          if (
            ex.data !== null &&
            ex.data !== undefined &&
            ex.data.nuOk !== -1
          ) {
            this.$vs.dialog({
              color: 'warning',
              title: 'Información',
              text: ex.data.errorDesc,
              acceptText: 'Aceptar'
            })
          } else {
            this.$vs.dialog({
              color: 'danger',
              title: 'Error',
              text: 'No es posible consultar la base de datos',
              acceptText: 'Aceptar',
              accept: console.log('Ex:', ex)
            })
          }
        })
    }
  }
}
</script>

<style lang="scss">
#avatar-col {
  width: 10rem;
}

#page-user-view {
  table {
    td {
      vertical-align: top;
      min-width: 140px;
      padding-bottom: 0.8rem;
      word-break: break-all;
    }

    &:not(.permissions-table) {
      td {
        @media screen and (max-width: 370px) {
          display: block;
        }
      }
    }
  }
}

// #account-info-col-1 {
//   // flex-grow: 1;
//   width: 30rem !important;
//   @media screen and (min-width:1200px) {
//     & {
//       flex-grow: unset !important;
//     }
//   }
// }

@media screen and (min-width: 1201px) and (max-width: 1211px),
  only screen and (min-width: 636px) and (max-width: 991px) {
  #account-info-col-1 {
    width: calc(100% - 12rem) !important;
  }

  // #account-manage-buttons {
  //   width: 12rem !important;
  //   flex-direction: column;

  //   > button {
  //     margin-right: 0 !important;
  //     margin-bottom: 1rem;
  //   }
  // }
}
</style>
